<template>
  <div class="templatebody" :style="note">
    <div>
      <heard></heard>
    </div>
    <div class="flex-all-center" style="margin-top: 3%">
      <div class="back-color-white width-45">
        <div class="back-color-db register-from-padding">
          <p class="l-p text-white">用户注册 - 欢迎您来到云航迹</p>
        </div>
        <div class="flex-jucenter register-from-margin">
          <el-form
            :model="form"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="0.5208333333333334rem"
            class="demo-form width-60"
          >
            <el-form-item label="公司名称 ">
              <el-input
                v-model="form.name"
                placeholder="请输入公司名称"
                @input="checkLong"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号码 ">
              <el-input
                v-model="form.phone"
                maxlength="11"
                placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码 ">
              <el-input
                placeholder="请输入短信验证码"
                v-model="form.code"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  @click="getVerify"
                  style="width: 0.7291666666666666rem;background:#407088;color:#fff;border:none "
                  :disabled="(disabled = !show)"
                >
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count"
                    >{{ count }} s</span
                  ></el-button
                >
              </el-input>
            </el-form-item>
            <el-form-item label="登录密码 " prop="pass">
              <el-input
                type="password"
                v-model="form.pass"
                autocomplete="off"
                maxlength="20"
                show-password="true"
                placeholder="请设置6-20位登录密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码确认 " prop="checkPass">
              <el-input
                type="password"
                v-model="form.checkPass"
                autocomplete="off"
                maxlength="20"
                show-password="true"
                placeholder="请再次输入登录密码"
              >
              </el-input>
            </el-form-item>

            <el-checkbox
              label=""
              name="type"
              v-model="checked"
             
              :checked="false"
              true-label="1"
              false-label="2"
              >我已阅读并同意《用户协议和隐私条款》</el-checkbox
            >
            <el-form-item style="margin-top: 1%"> </el-form-item>
          </el-form>
        </div>
        <el-button
          class="width-50"
          type="primary"
          style="margin-bottom: 3%"
          @click="nameber()"
          >注 &nbsp; 册<i class="el-icon-s-promotion el-icon--right"></i>
        </el-button>
      </div>
    </div>
    <div class="buttom-text1">
      <p>
        版权所有：海南云航翊信息科技有限责任公司 Copyright ©2014.Company name All rights
        reserved.
      </p>
    </div>
   
  </div>
</template>
<script>
import "@/assets/css/home.css";
import "@/assets/css/public.css";
import heard from "../public/heard.vue";
export default {
  name: "Home",
  components: {
    heard,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.checkPass !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      const reg =
        /^0?(13[0-9]|15[012356789]|18[0-9]|14[578]|16[6]|17[035768]|19[19])[0-9]{8}$/;
      if (reg.test(value)) {
        return callback();
      }
      callback("请输入合法的手机号");
    };
    return {
      checked: false,
      show: true,
      count: "", // 初始化次数
      timer: null,
      form: {
        name: "",
        phone: "",
        code: "",
        pass: "",
        checkPass: "",
        long:''
      },
      rules: {
        pass: [
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
        checkPass: [
          {
            validator: validatePass2,
            trigger: "blur",
          },
        ],
      },
      note: {
        backgroundImage:
          "url(" + require("../../assets/img/bg-login.jpg") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      },
    };
  },
  mounted() {},
  methods: {
    checkLong(){
          this.str(this.form.name)
          
    },
    str(str){
				var strlen = 0;
				for(var i = 0;i < str.length; i++){
				if(str.charCodeAt(i) > 255) //如果是汉字，则字符串长度加2
				strlen += 2;
				else
				strlen++;
				}
				this.long = strlen
        
			},
    nameber() {
   
      if (this.checked == 1) {
        if (this.form.name == "") {
          this.$message({
            showClose: true,
            message: "公司名称不能为空",
            type: "warning",
          });
          return;
        }else if(this.long>60){
              this.$message({
            showClose: true,
            message: "公司名称不能超过60位",
            type: "warning",
          });
          return
        }
        
        if (this.form.phone == "") {
          this.$message({
            showClose: true,
            message: "手机号不能为空",
            type: "warning",
          });
          return;
        }
          if (this.form.code == "") {
          this.$message({
            showClose: true,
            message: "验证码不能为空",
            type: "warning",
          });
          return;
        }
        if(this.form.pass.length<6 || this.form.pass.length>=20){
                 this.$message({
            showClose: true,
            message: "密码应为6-20位",
            type: "warning",
          });
          return;
        }
        if(this.form.pass != this.form.checkPass){
                 this.$message({
            showClose: true,
            message: "两次密码输入不一致",
            type: "warning",
          });
          return
        }
        for(let i=0;i<this.form.pass.length;i++){
           if(this.form.pass.charCodeAt(i)>255){
               this.$message({
            showClose: true,
            message: "密码不能包含中文",
            type: "warning",
          });
          return
           }
        }

        this.$source
          .post("/v1/servicer/register", {
            name: this.form.name,
            password: this.form.pass,
            phone: this.form.phone,
            verification_code: this.form.code,
          })
          .then((res) => {
            if (res.body.code == 20200) {
              let userName = res.body.data.account_name;
              this.$message({
                showClose: true,
                message: "注册成功",
                type: "success",
              });
              this.$router.push({
                name: "success",
                params: { userName: userName },
              });
            } else {
              this.$message({
                showClose: true,
                message: res.body.message,
                type: "warning",
              });
            }
          });
      } else {
        this.$message({
          showClose: true,
          message: "请勾选条款",
          type: "warning",
        });
      }
    },
    getVerify() {
      // 验证手机号1

      if (this.checkPhone() == false) {
        return false;
      } else {
        this.$source
          .post("/v1/code/send", {
            phone: this.form.phone,
            use_for: "注册",
            minute:30
          })
          .then(
            (res) => {
              console.log(res);
            },
            (err) => {
              console.log(err);
            }
          );

        const TIME_COUNT = 60; //更改倒计时时间
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer); // 清除定时器
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    checkPhone() {
      let phone = this.form.phone;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message.error("请填写正确的手机号");
        return false;
      }
    },
  },
};
</script>
<style scoped>
.buttom-text1 {
	color: #ADADAD;;
	height: 25px;
	width: 100%;
	min-width: 1280px;
    
	position: absolute;
	bottom: -40px;
	font-family: "SimHei";
}
.el-button{
  border-radius: 0;
}
.el-button--primary {
  background-color: #fd9405;
  border-color: #fd9405;
  font-size: 0.10416666666666667rem ;
}

.el-button--primary:hover {
  background-color: #fd9405;
  border-color: #fd9405;
}

.el-button--primary:focus {
  background-color: #fd9405;
  border-color: #fd9405;
}

>>> .el-form-item__label {
  font-size: 0.10416666666666667rem ;
  color: #444;
}
.el-input__inner {
  height: 0.22916666666666666rem ;
  font-size: 0.08854166666666667rem ;
}
.templatebody {
  min-height: 95vh;
}

</style>



// WEBPACK FOOTER //
// src/components/log/register.vue